import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ThreeWordsService {

  protected _3WordsAPI;

  constructor() {
    this._3WordsAPI = window['_3WordsAPI'];
    this._3WordsAPI.DEBUG = true;
  }

  /**
   * Convert coordinates to the 3 words.
   * @param {number} lat
   * @param {number} lng
   * @returns {string}
   */
  encode (lat, lng) { return this._3WordsAPI.encode(lat, lng); }

  /**
   * Convert 3 words to coordinates
   * @param {string} words
   * @returns {{lat: number, lng: number}}
   */
  decode (words) { return this._3WordsAPI.decode(words); }

  /**
   * Create cache entry for the specified coordinates.
   * This is used to reduce amount of requests to the 3 words servers.
   * @param {number} lat
   * @param {number} lng
   * @param {string} words
   */
  cacheSet (lat, lng, words) { return this._3WordsAPI.cacheSet(lat, lng, words); }

  /**
   * Get cache entry correpsonding to the specified coordinates.
   * If not found false is returned.
   * @param {number} lat
   * @param {number} lng
   * @returns {string|boolean}
   */
  cacheGet (lat, lng) { return this._3WordsAPI.cacheGet(lat, lng); }
}
